//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'HowExtraWorksItem',
  props: {
    number: String,
    numberText: Number,
    image: String
  }
};